export default __webpack_public_path__ + "static/media/yellowOnboardingGraphicThumb.34c10c71.svg";